import { useTranslations } from 'next-intl'

import NoResultIcon from './NoResults'

export const EmptyState = () => {
	const t = useTranslations()

	return (
		<div className="flex flex-col items-center justify-center gap-4 pt-30">
			<NoResultIcon />
			<div className="flex flex-col items-center justify-center gap-2">
				<span className="type-heading-4 text-black">
					{t('dashboard__qr_table__empty_search__title')}
				</span>
				<span className="text-dark-gray type-body-small">
					{t('dashboard__qr_table__empty_search__description')}
				</span>
			</div>
		</div>
	)
}
